import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

declare const __BUILD_SENTRY_DSN__: string;
declare const __BUILD_SENTRY_ENVIRONMENT__: string;

Sentry.init({
  dsn: __BUILD_SENTRY_DSN__ || "",
  environment: __BUILD_SENTRY_ENVIRONMENT__ || "development",
  integrations: [
    Sentry.reactRouterBrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0.2,
});
